export function getAzureConfig() {
  return (
    (window.Distinction && window.Distinction.azureSearchConfig) || {
      serviceName: "scor-webmock-search",
      workplaceIndexName: "workplaces",
      queryKey: "579B96D322782A9BE980C0443CA80222",
      suggesterName: "Sg",
    }
  );
}
